import { userConstants } from './../constants/user.constants';

let user = sessionStorage.getItem('user');
const initialState = user ? { user, isLoading: false } : {};

export function UserSearchDefault(state = initialState, action) {
  
  console.log("inside Insubmission function", action)
  switch (action.type) {
    case userConstants.USERSEARCHDEF_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.USERSEARCHDEF_SUCCESS:
      const {res} = action
        console.log("Action", action)
      return {
        res,
        isLoading : false
      };
    case userConstants.USERSEARCHDEF_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}